<script setup lang="ts">
import { computed } from 'vue'

import Select from '@mobile/components/Select/Select.vue'
import { SelectOption } from '@mobile/components/Select/types/SelectOption'

import GroupTitle from './GroupTitle.vue'

interface Props {
  name: string
  options: SelectOption[]
  trackBy?: string
  important?: boolean
  isFulfilled?: boolean
  nullable?: boolean
  disabled?: boolean
}

const props = defineProps<Props>()

// emits
defineEmits<{
  (e: 'searchChange', search: string): void
}>()

// data
const notSelectedSelectOption: SelectOption = {
  name: 'None',
  value: null,
}

// computed
const filteredSelectOptions = computed(() => {
  if (props.nullable) {
    return [notSelectedSelectOption, ...props.options]
  }

  return props.options
})

// models
const model = defineModel<InstanceType<typeof Select>['$props']['value']>()
</script>

<template>
  <GroupTitle
    :name
    :important
    :isFulfilled
  />

  <Select
    v-model="model"
    label="name"
    :mode="'single'"
    :options="filteredSelectOptions"
    searchable
    :trackBy
    :disabled
    @searchChange="$emit('searchChange', $event)"
  />
</template>
